<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class=" w-full  vx-row no-gutter justify-center items-center">
   
    <vs-navbar type="gradient" v-model="activeItem" class="nabarx pr-3 pl-3">

<div slot="title">
  <vs-navbar-title>
    <img src="/logo-connecthr.png" height="50" width="auto" alt="">
  </vs-navbar-title>
</div>

<vs-navbar-item activeItem>
  <a href="#">Vagas</a>
</vs-navbar-item>

<vs-navbar-item index="1">
  <a href="#">Voltar ao website</a>
</vs-navbar-item>

<vs-navbar-item index="2">
  <a href="#">Update</a>
</vs-navbar-item>
<vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="search" />
</vs-navbar>
<!-- /////////////////////////////////////////////// NAVBAR //////////////////////////////////////// -->
    <div class="vx-col mt-5 w-full ">
      <vs-row>
        <vx-card v-for="vaga in vagas" class="w-1/4 mr-5">
        <!-- sm:w-1/2 md:w-1/2 lg:w-2/5 m-4 -->
       

        <img src="/pasta.png" alt="coming-soon" class="mx-auto mb-1" width="80">
        <div class="vx-card__title mb-3">
          <h4 class="text-center">{{vaga.title}}</h4>
        </div>
        <div class="count-down text-center">
         
        </div>

        <vs-divider position="center">Descrição</vs-divider>

        <div class="subscription">

          <span>{{ vaga.description }}</span>
          <vs-button class="w-full">Detalhes da vaga</vs-button>

        </div>
      </vx-card>
    
     
      </vs-row>
     
    </div>
  </div>
</template>


<script>
import http from '../../../http-common';
export default {
  data() {
    return {
      value1: '',
      vagas:[],
    }
  },
  components: {
  },

  mounted() {
    this.getVagas();

  },
  methods: {
    getVagas() {
      

      http
        .get("/jobs/list")
        .then((result) => {
         this.vagas=result.data.data
        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },
  },
}

</script>

